import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import useContinueShopping from "./useContinueShopping";

export default function () {
  const { reset, handleSubmit, setErrors, setData, continueShoppingFields } = useContinueShopping();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`continue-shopping`).then(res => {
      setData(res.data.data);
      reset({'products': res.data.data.product_list});
    });
  }, []);

  const editContinueShopping = data => {
    axios.put(  `continue-shopping`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Continue Shopping Products has been updated successfully!', {
            icon: "success",
          });
          navigate("/continue-shopping");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit continue shopping products">
      <form className="form w-100 row" onSubmit={handleSubmit(editContinueShopping)}>
        {continueShoppingFields}
        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}